import React from "react";
import "./Footer.css";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="logo">Garishtha Wellness</div>
        <div className="footer-links">
          <a href="/">Home</a>
          <a href="/">About</a>
          <a href="/">Team</a>
          <a href="/">Process</a>
          <a href="/">Pricing</a>
          <a href="/">Blog</a>
          <a href="/">Contact</a>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="contact-box">
          <FaEnvelope className="icon" />
          <span>garishtha.wellness@gmail.com</span>
        </div>
        <div className="contact-box">
          <FaPhone className="icon" />
          <span>+91 84508 77828</span>
        </div>
        <div className="contact-box">
          <FaMapMarkerAlt className="icon" />
          <span>Remote</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
